import { Frame, Pages } from '~/lib';

/**
 * Count of items in product lists are decided by the following in order:
 * 1. (Page type) Search page takes it from Search Settings while most pages will have it on their page settings.
 * 2. (Global settings) Taken from Product Settings.
 * 3. (Default) Default page size is 40.
 */
export const extractPageSize = (page: Pages, frame: Frame) => {
    const productListPageSize =
        (page.type === 'p10SearchPage' ? frame.search?.SearchPageSize : page.productListPageSize) ||
        frame.productSettings?.pageSize ||
        40; // Default fallback if no CMS settings are found

    return productListPageSize;
};
